import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import classes from "./FssShiftStartMessage.module.scss"

const FssShiftStartMessage = (props) => {
  const { setContent } = props

  const [t] = useTranslation()

  const handleNavigate = () => {
    setContent("startShiftPage")
  }

  return (
    <Fragment>
      <div className={classes["title"]}>
        {t("شیفت_به_اتمام_رسیده")}
      </div>

      <div className={classes["text"]}>
        {t("جهت_ادامه_شیفت_را_شروع_کنید")}
      </div>

      <Button
        color="success"
        onClick={handleNavigate}
      >
        {t("شروع_شیفت")}
      </Button>
    </Fragment>
  )
}

export default FssShiftStartMessage